import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AccountServiceProvider } from "@webapp/accounts/providers/account.provider";
import { GetDataSourceBlueprintLogoPipe } from "@webapp/data-story/pipes/get-datasource-blueprint-logo.pipe";
import { InsightFilterPipe } from "@webapp/data-story/pipes/insight-filter.pipe";
import { InsightSelectorServiceProvider } from "@webapp/data-story/providers/insight-selector.service.provider";
import { AutoInsightsApiService } from "@webapp/data-story/services/auto-insights-facade/auto-insights-api.service";
import { AutoInsightsFacade } from "@webapp/data-story/services/auto-insights-facade/auto-insights-facade.service";
import { AutoInsightsState } from "@webapp/data-story/services/auto-insights-facade/auto-insights-state.service";
import { UIErrorHandlingServiceProvider } from "@webapp/error-handling/providers/ui-error-handling-service.provider";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { BasicAutomationComponent } from "@webapp/shared/components/item-automation/components/basic-automation/basic-automation.component";
import { SelectedAutomationComponent } from "@webapp/shared/components/item-automation/components/selected-automation/selected-automation.component";
import { SuggestedAutomationComponent } from "@webapp/shared/components/item-automation/components/suggestions-automation/suggested-automation.component";
import { ItemAutomationComponent } from "@webapp/shared/components/item-automation/item-automation.component";
import { InsightUsageMessagePipe } from "@webapp/shared/components/item-automation/pipes/insight-usage-message.pipe";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { UibModalProvider } from "@webapp/shared/providers/uib-modal.provider";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocalizationModule,
    UiIconModule,
    UiButtonModule,
    NgOptimizedImage,
    IndicatorModule,
    GetDataSourceBlueprintLogoPipe,
    UiTooltipModule,
  ],
  declarations: [
    InsightFilterPipe,
    ItemAutomationComponent,
    BasicAutomationComponent,
    SelectedAutomationComponent,
    SuggestedAutomationComponent,
    InsightUsageMessagePipe,
  ],
  exports: [ItemAutomationComponent],
  providers: [
    AutoInsightsFacade,
    AutoInsightsState,
    AutoInsightsApiService,
    UibModalProvider,
    UIErrorHandlingServiceProvider,
    InsightSelectorServiceProvider,
    AccountServiceProvider,
  ],
})
export class ItemAutomationModule {}
